/**
 * Determines if a string contains only Latin script characters plus allowable characters.
 *
 * This function checks if the input text consists entirely of:
 * - Latin script characters (including accented characters like á, é, ö, etc.)
 * - Numbers (0-9)
 * - Punctuation marks (.,:;!? etc.)
 * - Whitespace characters (spaces, tabs, etc.)
 * - Common symbols (@#$%^&*+-= etc.)
 *
 * Any characters outside of these groups (such as Chinese, Japanese, Arabic, Hebrew,
 * Cyrillic, etc.) will cause the function to return false.
 *
 * @param text - The string to check for non-Latin script characters
 * @returns true if the string contains only Latin script and allowable characters,
 *          false if it contains any non-Latin script characters
 *
 * @example
 * ```typescript
 * isLatinString('Hello world!'); // Returns true
 * isLatinString('Hello 123 @#$'); // Returns true
 * isLatinString('こんにちは'); // Returns false (Japanese characters)
 * isLatinString('Hello世界'); // Returns false (mixed Latin and Chinese characters)
 * isLatinString(''); // Returns true (empty string is considered valid)
 * ```
 */
export function isLatinString(text) {
    if (!text) {
        return true; // Empty strings are considered valid
    }
    // This regex checks if the string contains any characters outside of:
    // Latin script characters, numbers, punctuation, whitespace, and symbols
    const nonLatinRegex = /[^\p{Script=Latin}\p{N}\p{P}\p{Z}\p{S}]/gu;
    // Return true if only Latin characters are found
    return !nonLatinRegex.test(text);
}
//# sourceMappingURL=IsLatinString.js.map